import { UndoOutlined } from '@ant-design/icons';
import { useCallback } from 'react';

import { StyledButton } from '../ImageViewer.style';

type RotateProps = {
  onChange: (data: any) => void;
  value?: boolean;
  disabled?: boolean;
  title?: string;
};

export const Rotate: React.FunctionComponent<RotateProps> = ({
  onChange,
  value = false,
  disabled = false,
  title = 'Rotate',
}) => {
  const handleClick = useCallback(() => {
    onChange({ rotate: !value });
  }, [value, onChange]);

  return (
    <StyledButton
      data-testid="image-controls-rotate"
      title={title}
      type={value ? 'primary' : 'default'}
      onClick={handleClick}
      disabled={disabled}
    >
      <UndoOutlined />
    </StyledButton>
  );
};
